export const ENV_VARS_KUBE = {
  VUE_APP_ENV: "prod",
  VUE_APP_IAM_REALM: "swascan",
  VUE_APP_IAM_CLIENT_ID: "swascan",
  VUE_APP_I18N_LOCALE: "it",
  VUE_APP_I18N_FALLBACK_LOCALE: "it",
  VUE_APP_SHOW_NOTIFICATION: "",
  VUE_APP_SHOW_MODAL_NOTIFICATION: "",
  VUE_APP_NAME: "frontend",
  VUE_APP_OLD_PLATFORM: "https://security.swascan.com/",
  VUE_APP_RESET_PASSWORD: "https://security.swascan.com/accounts/password/reset/",
  VUE_APP_SIGN_UP: "https://security.swascan.com/accounts/signup/",
  VUE_APP_PERMITTED_LICENSES: "dti,nscan,phishing_attack,smishing_attack,cti,cyber_threat,tvm,dti_lite,rri,webapp,cardp,ir,survey,survey_ict,survey_gdpr,survey_nis2,helperbot",
  VUE_APP_IAM_BASE_URL: "https://iam.platform.swascan.com/auth",
  VUE_APP_API_BASE_URL: "https://core.platform.swascan.com/core",
  VUE_APP_BACKEND_BASE_URL: "https://backend.platform.swascan.com",
  VUE_APP_LICENSE_BASE_URL: "https://licensing.platform.swascan.com/licensing",
  VUE_APP_REST_BASE_URL: "https://rest.platform.swascan.com",
  VUE_APP_SWASCAN_INFO_EMAIL: "mailto:info@swascan.com",
  VUE_APP_VULNERABILITY_EARLY_WARNING_ENV_KEY: "PROD",
  VUE_APP_FORCE_KEYCLOAK: "false",
  VUE_APP_FORCE_STANDALONE: "false",
};
